var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('VueEditor',{on:{"input":function (i) { return (_vm.page = i); }}}),_c('DynamicPageRenderer',{attrs:{"page":_vm.page}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }